import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface ClientsDialogProps {
    open: boolean;
}

const initialState: ClientsDialogProps = { open: false };

const clientsDialogSlice = createSlice({
    name: 'clientsDialog',
    initialState,
    reducers: {
        openClientsDialog: (state) => {
            state.open = true;
            return state;
        },
        closeClientsDialog: (state) => {
            state = initialState;
            return state;
        },
    },
});

export const { openClientsDialog, closeClientsDialog, } = clientsDialogSlice.actions;
export default clientsDialogSlice.reducer;
export const selectClientsDialog = (state: RootState) => state.clientsDialog;